export type ConfigState = {
  layout: string;
  background: string;
  navbar: string;
  topNavigation: string;
  collapsed: boolean;
  logo: string;
  leftSidebar: string;
  rightSidebar: boolean;
  hideNavbar: boolean;
};

export function config(
  state: ConfigState = {
    layout: 'top-navigation-1',
    background: 'dark',
    navbar: 'dark',
    topNavigation: 'info',
    collapsed: true,
    logo: 'info',
    leftSidebar: 'light',
    rightSidebar: false,
    hideNavbar: false
  },
  action: { type: string; config?: Partial<ConfigState> }
): ConfigState {
  switch (action.type) {
    case 'SET_CONFIG':
      return { ...state, ...action.config };
    default:
      return state;
  }
}
